<template>

    <!-- UI -->
    <nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

    <nav class="nav-extended blue-grey darken-3 hide-on-small-only">
        <div class="nav-wrapper container">
            <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
            <ul class="right hide-on-med-and-down">
                <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }">
                    <a href="#" @click.prevent="handleActive(tab)">{{ tab.title }}</a>
                </li>
            </ul>
        </div>
        <div class="nav-content container">
            <!-- Add Button -->
            <span class="hide-on-med-and-down" v-if="isReady">
                <a class="left btn-floating btn-large halfway-fab waves-effect waves-light blue darken-2"
                    title="Add Encounter"
                    @click.prevent="handleActive(tabs?.find(x => x.title.toLowerCase() == 'request'))">
                    <i class="material-icons">add</i>
                </a>
            </span>
        </div>
    </nav>

    <!-- Mobile only -->
    <nav class="blue-grey darken-4 hide-on-large-only">
        <ul class="tabs tabs-transparent">
            <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
                <a href="#" @click.prevent="handleActive(tab)">{{ tab?.title?.split(" ")[0] }}</a>
                <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
            </li>
        </ul>
    </nav>

    <!-- Search Nav -->
    <nav class="nav-extended teal darken-3">
        <div class="nav-wrapper blue-grey darken-2 container z-depth-4">
            <form>
                <div class="input-field">
                    <input id="search" type="search" v-model="searchItem" placeholder="Search by Name, ID, Client..."
                        autocomplete="off" />
                    <label class="label-icon" for="search"><i class="material-icons">search</i></label>
                    <i class="material-icons white-text orange" @click="handleClearSearch" v-if="searchItem">clear</i>
                </div>
            </form>
        </div>
    </nav>

    <!-- Loader -->
    <div class="container progress" v-if="isLoading">
        <div class="indeterminate"></div>
    </div>

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

    <!-- breadcrumbs -->
    <nav class="grey lighten-4 z-depth-0">
        <div class="container nav-wrapper">
            <div class="col s12">
                <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i>
                        Dashboard</small></router-link>
                <span class="breadcrumb blue-grey-text pointable"><small>Encounter Home</small></span>
            </div>
        </div>
    </nav>

    <!-- Top -->
    <div id="top"></div>

    <div class="container">
        <!-- <div class="row">
            <div class="col s12"> -->

        <!-- Vetting Marker -->
        <div id="review"></div>

        <LoadingDiv v-if="!isReady" />

        <div v-else>

            <div class="section">

                <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-if="encounters.length" />

                <div class="card" v-for="(encounter, index) in encounters" :key="encounter.id">
                    <!-- Main -->
                    <div class="card">
                        <div class="card-content grey lighten-4 hide-on-med-and-down">
                            <div class="row">
                                <div class="col s1 center-align">#{{ index + 1 }}</div>
                                <div class="col s3">Enrollee <small>(Bio)</small></div>
                                <div class="col s2">ID <small>(Scheme)</small></div>
                                <div class="col s3">Diagnosis</div>
                                <div class="col s2">Time <small>{{!encounter?.claims?.find(x => x.authorization === 'z'
                                    && x.status === 'a') ?
                                    '(Response)' : '(Request)' }}</small></div>
                                <div class="col s1"><br /></div>
                            </div>
                        </div>

                        <div class="card-content hide-on-med-and-down" :class="{
                            'grey lighten-5': (index + 1) % 2 === 1,
                        }" @mouseenter.prevent="handleHover(encounter, 'in')"
                            @mouseleave.prevent="handleHover(encounter, 'out')">
                            <div class="row">
                                <div class="col s1">
                                    <img :src="encounter.profile_img" width="64" class="circle responsive-img right"
                                        v-if="encounter.profile_img" />
                                    <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="64"
                                        class="circle responsive-img right" v-else />
                                </div>
                                <div class="col s3">
                                    <h6>
                                        <span class="new badge" data-badge-caption="principal"
                                            v-if="encounter.type == 'p'"></span>
                                        <span class="new badge orange" data-badge-caption="dependant"
                                            v-if="encounter.type == 'd'"></span>
                                        <b>{{ encounter.name }}</b>
                                        <br />
                                        <small><span class="blue-text"><b>{{
                                            showAgeSex(encounter?.dob, encounter?.sex)
                                                    }}</b></span></small>
                                        <br />
                                        {{ encounter.phone }}
                                        <br /><br />
                                        <span class="chip black-text text-accent-3 pointable"
                                            :title="encounter.picked_provider"
                                            v-if="encounter.picked_provider_id && encounter.provider_id && encounter.picked_provider_id !== encounter.provider_id">Referral</span>
                                    </h6>
                                </div>
                                <div class="col s2">
                                    <p>
                                        {{ encounter.enrollee_number }}
                                        <br />
                                        (<b>{{ encounter.scheme.name.toUpperCase() }}</b>)
                                        <br />
                                        <small>{{ encounter.client_name }}</small>
                                    </p>
                                </div>
                                <div class="col s3">
                                    <p class="orange-text text-accent-3" v-if="encounter.diagnosis">
                                        {{ encounter.diagnosis }}
                                    </p>
                                    <p class="chip yellow" v-else>No Diagnosis</p>
                                </div>
                                <div class="col s2">
                                    <p class="chip"
                                        :class="{ 'green-text': !encounter?.claims?.find(x => x.authorization === 'z' && x.status === 'a') }">
                                        {{
                                            new Date(encounter.updated_at).toLocaleString(
                                                undefined,
                                                {
                                                    hour: "numeric",
                                                    minute: "numeric",
                                                    hour12: true,
                                                }
                                            )
                                        }}
                                    </p>
                                </div>
                                <div class="col s1">
                                    <a class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2 right"
                                        :class="{ pulse: encounter.id === curr?.id }"><i class="material-icons"
                                            @click.prevent="handleUpdate(encounter)"
                                            title="Request Authorization">insert_comment</i></a>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Mobile -->
                    <div class="card-content hide-on-large-only" :class="{
                        'grey lighten-5': (index + 1) % 2 === 1,
                    }" @mouseenter.prevent="handleHover(encounter, 'in')"
                        @mouseleave.prevent="handleHover(encounter, 'out')">

                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <td>Name <small>(Age/Sex)</small></td>
                                    <td>ID <small>(Scheme)</small></td>
                                    <td>Diagnosis</td>
                                    <td>Time</td>
                                    <td></td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>{{ index + 1 }} ({{ encounter.scheme.name.toUpperCase() }})</td>
                                    <td>
                                        <b>{{ encounter.name }}</b> &nbsp;

                                        <small><span class="teal-text"><b>{{
                                            showAgeSex(encounter.dob, encounter.sex)
                                                    }}</b></span> </small>
                                        <br /><br />
                                        <span class="chip black-text text-accent-3 pointable"
                                            :title="encounter.picked_provider"
                                            v-if="encounter.picked_provider_id && encounter.provider_id && encounter.picked_provider_id !== encounter.provider_id">Referral</span>
                                    </td>
                                    <td>
                                        {{ encounter.enrollee_number }}

                                    </td>
                                    <td>
                                        <span class="orange-text text-accent-3" v-if="encounter.diagnosis">
                                            {{ encounter.diagnosis }}
                                        </span>
                                        <span class="chip yellow" v-else>No Diagnosis</span>
                                    </td>
                                    <td>
                                        <p class="chip"
                                            :class="{ 'green-text': !encounter?.claims?.find(x => x.authorization === 'z' && x.status === 'a') }">
                                            {{
                                                new Date(encounter.updated_at).toLocaleString(
                                                    undefined,
                                                    {
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                        hour12: true,
                                                    }
                                                )
                                            }}
                                        </p>
                                    </td>
                                    <td>
                                        <a class="waves-effect waves-light btn light-blue lighten-2"
                                            :class="{ pulse: encounter.id === curr?.id }"
                                            @click.prevent="handleUpdate(encounter)">Request
                                            <i class="material-icons"
                                                title="Request Authorization">insert_comment</i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <!-- Approvals -->
                    <div class="card" v-if="encounter.claims.length">
                        <ol class="collection" :class="{
                            'blue-grey lighten-5': (index + 1) % 2 === 1,
                        }">
                            <span v-for="claim in encounter.claims.slice().reverse()" :key="claim.id">
                                <!-- approved -->
                                <span v-if="claim.authorization == 'y'">
                                    <li class="collection-item"
                                        :class="{ 'grey lighten-2': claim.sent_price == 0, 'green lighten-4': claim.sent_price != 0 }"
                                        v-if="claim.sent_price === claim.approved_price">
                                        <b>{{ claim.item }}</b> x {{ claim.sent_qty }}
                                        (₦{{
                                            Number(claim?.sent_price)
                                                .toFixed(2)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                        }}) <span v-if="claim.sent_price != 0">-> (Approved)</span> ->
                                        <span class="blue-text tooltipped pointable" data-position="top"
                                            :data-tooltip="claim.comment" v-if="claim.comment">({{
                                                claim.authorization_code }})</span>
                                        <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                                        <span class="secondary-content pointable"
                                            :class="{ 'black-text': claim.sent_price == 0, 'green-text': claim.sent_price != 0 }"
                                            :title="claim.sent_price == 0 ? 'Completed' : 'Approved'">
                                            <i class="material-icons hide-on-med-and-down">check_circle</i>
                                            <i class="tiny material-icons hide-on-large-only">check_circle</i>
                                        </span>
                                    </li>
                                    <li class="collection-item blue lighten-4" v-else>
                                        <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged:
                                        ₦{{
                                            Number(claim?.sent_price)
                                                .toFixed(2)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                        }}) -> x {{ claim.approved_qty }} (Approved: <b> ₦{{
                                            Number(claim?.approved_price)
                                                .toFixed(2)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                        }}</b>) ->
                                        <span class="blue-text text-darken-4 tooltipped pointable" data-position="top"
                                            :data-tooltip="claim.comment" v-if="claim.comment">({{
                                                claim.authorization_code }})</span>
                                        <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                                        <span class="secondary-content green-text pointable" title="Approved">
                                            <i class="material-icons hide-on-med-and-down">check_circle</i>
                                            <i class="tiny material-icons hide-on-large-only">check_circle</i>
                                        </span>
                                    </li>
                                </span>

                                <!-- pending -->
                                <li class="collection-item lime lighten-4 pointable"
                                    v-if="claim.authorization == 'z' && claim.status == 'a'" title="pending request">
                                    <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged:
                                    ₦{{
                                        Number(claim?.sent_price)
                                            .toFixed(2)
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    }})

                                    <span class="secondary-content orange-text pointable" title="Pending">
                                        <i class="material-icons hide-on-med-and-down">watch_later</i>
                                        <i class="tiny material-icons hide-on-large-only">watch_later</i>
                                    </span>
                                </li>

                                <!-- declined -->
                                <li class="collection-item red lighten-4"
                                    v-if="claim.authorization == 'z' && claim.status == 'd'">
                                    <s>
                                        <span class="tooltipped pointable" data-position="top"
                                            :data-tooltip="claim.comment" v-if="claim.comment">
                                            <b>{{ claim.item }}</b> x
                                            {{ claim.sent_qty }} (Charged: ₦{{
                                                Number(claim?.sent_price)
                                                    .toFixed(2)
                                                    .toString()
                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                            }})
                                        </span>

                                        <span v-else>
                                            <b>{{ claim.item }}</b> x
                                            {{ claim.sent_qty }} (Charged: ₦{{
                                                Number(claim?.sent_price)
                                                    .toFixed(2)
                                                    .toString()
                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                            }})
                                        </span>
                                    </s>

                                    <span class="secondary-content red-text pointable" title="Declined">
                                        <i class="material-icons hide-on-med-and-down">cancel</i>
                                        <i class="tiny material-icons hide-on-large-only">cancel</i>
                                    </span>
                                </li>
                                <div class="divider"></div>
                            </span>
                        </ol>
                    </div>

                </div>
            </div>

            <div class="section center" v-if="!encounters?.length">
                <h6>
                    <img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" />
                </h6>
            </div>

            <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </div>

    </div>
    <!-- </div>
    </div> -->
</template>

<script>
import { computed, onMounted, onUnmounted, ref, watch, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import getItemsOfItems from "@/composables/getItemsOfItems";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import { ageSex } from "@/composables/fxLibrary/coreFx.js";
import { getCache, addCache } from "@/composables/cache/cache";
import M from "materialize-css";


export default {
    name: "encounterHome",
    components: { LoadingDiv, PaginationDiv },
    setup() {
        const response = ref(null);
        const searchTitle = ref(null);
        const searchItem = ref(null);
        const isReady = ref(false);
        const isLoading = ref(false);
        const isEmpty = ref(true);
        const error = ref(null);
        const curr = ref(null);
        const currUrl = ref(null);
        const currHook = ref(null);
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);
        const intervalID = ref(null);
        // const homeUrl = ref(null);

        // router
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;

        // start
        onMounted(() => {
            // page name
            document.title = "All Encounters | EasyHMO";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Encounters", title: "All", icon: null, url: "encounter", hash: null, });
            tabs.value.push({ id: 2, name: "Encounters", title: "Request", icon: "add_circle", url: "encounterAdd", hash: null, });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("All"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("All"));
        });

        // starter
        onMounted(() => {
            // start
            getStared();
        });

        // start
        const getStared = () => {
            // set current Url
            currUrl.value = `encounter/provider/search`;
            // set current Hook
            currHook.value = "&";
            // get searchItem items from function
            getItemsFromApi(currUrl.value, providerId);
        }

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // numbering
        const numberBadge = (num) => {
            return (
                (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
            );
        };

        // ageSex
        const showAgeSex = (dob, sex) => {
            const { fx } = ageSex(dob, sex);
            return fx.value;
        };

        // get time
        const timeSince = (val) => {
            // get first unresponded
            const useFirstSentDateTime = val.find(x => x.authorization == "z" && x.status != "d");

            // function
            const past = new Date(useFirstSentDateTime?.created_at);
            const now = new Date();
            const diffMs = now - past;

            const diffMins = Math.floor(diffMs / 60000);
            if (diffMins < 60) return `${diffMins} min${diffMins !== 1 ? 's' : ''}`;

            const diffHrs = Math.floor(diffMins / 60);
            if (diffHrs < 24) return `${diffHrs} hour${diffHrs !== 1 ? 's' : ''}`;

            const diffDays = Math.floor(diffHrs / 24);
            return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
        }

        // get function
        const getItemsFromApi = (table, id) => {

            // get item from store (cache)
            let cache = getCache(`${table}/${id}`);

            if (cache?.length) {
                response.value = cache;
            }

            (async () => {
                const { res, err } = await getItemsOfItems(table, id);

                if (res.value) {
                    response.value = res.value.data;
                    // add cache
                    addCache(`${table}/${id}`, response.value);
                    // set isEmpty to false
                    // isEmpty.value = isEmpty.value && response.value.data.length ? false : true;
                } else {
                    error.value = err.value;
                }

                // page is ready, loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        };

        // handle search (emitted from component)
        const handleSearch = () => {
            // start loading
            isLoading.value = true;
            // set current Url
            currUrl.value = `encounter/provider/search`;
            // set current Hook
            currHook.value = `?q=${searchItem.value}&`;
            // get items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}`);
        };

        // handle curr status
        const handleClearSearch = () => {
            // clear
            searchItem.value = null;
            // restarted
            getStared();
        };

        // search watcher
        watch(searchItem, (newVal, oldVal) => {
            if (newVal && newVal !== oldVal) {
                handleSearch();
            }
        });

        // switch page
        const handlePage = (page) => {
            // start ready
            isReady.value = false;
            // go back up
            router.push({ hash: "#top" });
            // get new page items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}page=${page}`);
        };

        // handle Edit
        const handleUpdate = (encounter) => {
            // Send to Encounter Add
            router.push({
                name: "encounterAdd",
                params: {
                    encounterId: encounter.id,
                },
            });
        };

        // output results
        const encounters = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value.data;
            }
        });

        // output pages
        const allPages = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value; // get all
            }
        });

        function startInterval() {
            intervalID.value = setInterval(() => {
                if (allPages.value.current_page == 1) {
                    getItemsFromApi(currUrl.value, providerId);
                }
            }, 600000); // 60000 ms = 1 minute
        }

        function stopInterval() {
            if (intervalID.value) {
                clearInterval(intervalID.value);
                intervalID.value = null;
            }
        }

        onMounted(() => {
            startInterval();
        });

        onUnmounted(() => {
            stopInterval();
        });

        // toolTip
        const toolTip = () => {
            var elems = document.querySelectorAll(".tooltipped");
            M.Tooltip.init(elems, {});
        };

        // hover effects
        const handleHover = (val, type) => {
            if (val && type) {
                if (type === "in") {
                    curr.value = val;
                }
                if (type === "out") {
                    curr.value = null;
                }
            }
        }

        // toolTip
        watchEffect(() => {
            if (response.value) {
                setTimeout(() => {
                    toolTip();
                }, 2000);
            }
        });

        return {
            handleActive,
            home,
            curr,
            currTab,
            tabs,
            ageSex,
            showAgeSex,
            numberBadge,
            timeSince,
            handlePage,
            handleSearch,
            handleClearSearch,
            handleUpdate,
            handleHover,
            isReady,
            isLoading,
            isEmpty,
            error,
            searchItem,
            searchTitle,
            encounters,
            allPages,
        };
    },
};
</script>

<style scoped>
.progress {
    margin-top: -15px;
}

.custom-hr {
    width: 50%;
    border: none;
    border-top: 2px solid #ccc;
    margin: 20px 20px;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
    color: rgb(21, 21, 206) !important;
}

.cancel-item:hover .material-icons.grey-text,
.cancel-item:hover .material-icons.grey-text::before {
    color: rgb(214, 16, 16) !important;
}

.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.clickable:hover {
    opacity: 0.8;
}

.pointable {
    cursor: default;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.pointable:hover {
    opacity: 0.8;
}

.custom-nav {
    height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
    font-weight: 300;
    font-size: 1.5rem;
}

.nav-wrapper ul li a {
    font-weight: 400;
    padding: 0 15px;
}

.nav-content {
    min-height: 20px;
}
</style>
